import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import { displayError } from 'src/app/modules/shared/utilities/notifications.utils';

import * as TermsAndConditionsActions from 'src/app/modules/ngrx-store/terms-and-conditions/terms-and-conditions.actions';
import { TermsAndConditionsService } from 'src/app/modules/core/services/terms-and-conditions.service';

@Injectable()
export class TermsAndConditionsEffects {
	constructor(
		private actions$: Actions,
		private termsAndConditionsService: TermsAndConditionsService,
	) { }

	loadTermsAndConditions$ = createEffect(() => this.actions$.pipe(
		ofType(TermsAndConditionsActions.loadTermsAndConditions),
		switchMap(() => this.termsAndConditionsService.getTermsAndConditions().pipe( 
			map((termsAndConditions) => TermsAndConditionsActions.loadTermsAndConditionsSuccess({ termsAndConditions })),
			catchError((err) => of(TermsAndConditionsActions.loadTermsAndConditionsFailure({ error: err })))
		))
	));

	loadTermsAndConditionsFailure$ = createEffect(() => this.actions$.pipe(
		ofType(TermsAndConditionsActions.loadTermsAndConditionsFailure),
		tap(({ error }) => {
			displayError(error);
		})
	),
	{ dispatch: false }
	);

	acknowledgeTermsAndConditions$ = createEffect(() => this.actions$.pipe(
		ofType(TermsAndConditionsActions.acknowledgeTermsAndConditions),
		switchMap(({ publishDate }) => this.termsAndConditionsService.acknowledgeTermsAndConditions(publishDate).pipe(
			map((termsAndConditions) => TermsAndConditionsActions.acknowledgeTermsAndConditionsSuccess({ termsAndConditions })),
			catchError((err) => of(TermsAndConditionsActions.acknowledgeTermsAndConditionsFailure({ error: err })))
		))
	));

	acknowledgeTermsAndConditionsFailure$ = createEffect(() => this.actions$.pipe(
		ofType(TermsAndConditionsActions.acknowledgeTermsAndConditionsFailure),
		tap(({ error }) => {
			displayError(error);
		})
	),
	{ dispatch: false }
	);
}